import { Toaster } from "react-hot-toast";
import AllRoutes from "./routes/AllRoutes";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";


const stripePromise = loadStripe("pk_test_51Q3JqXAk3rPClgNeNUhwblAMcUHZGovpvDdkpJQfpTiriYMkBw8bC4a0boU4TjU8tWhgkECwPQmw8oCgIvA0yLKE00ZWdMIpNm");


function App() {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      {/* Wrap all routes in Stripe Elements provider */}
      <Elements stripe={stripePromise}>
        <AllRoutes />
      </Elements>
    </>
  );
}

export default App;
